/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import Backbone from 'backbone';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import ShoppingSettings from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/shopping-settings';
import '@bingads-webui-campaign/ko-stop-binding';

import { getStyles } from './style';

// Only for sponsored campaigns
export const LegacyShoppingSettings = React.memo(({
  id,
  className,
  onChange,
  shoppingSettingsRef,
  shoppingSettingOptions,
}) => {
  const view = useRef();
  const viewListener = useMemo(() => _.clone(Backbone.Events), []);
  const { data } = shoppingSettingOptions;

  let container;

  useEffect(() => {
    if (_.isEmpty(data)) {
      return _.noop;
    }

    view.current = new ShoppingSettings(shoppingSettingOptions);

    shoppingSettingsRef.current = view.current;

    viewListener.listenTo(view.current, 'change', onChange);

    view.current.render();
    view.current.$el.appendTo(container);

    return () => {
      viewListener.stopListening(view.current);
      view.current.remove();
    };
  }, [data, shoppingSettingOptions.isCPSSelected]);

  const classes = useDefaultStyles(getStyles);

  return (
    <div
      id={id}
      className={classnames(className, classes.shoppingSettings)}
    >
      <div ref={(ref) => { container = ref; }} />
    </div>
  );
});

LegacyShoppingSettings.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  shoppingSettingsRef: PropTypes.shape({}).isRequired,
  shoppingSettingOptions: PropTypes.shape({
    data: PropTypes.shape({}),
    isCPSSelected: PropTypes.bool,
  }).isRequired,
};

LegacyShoppingSettings.defaultProps = {
  id: undefined,
  className: undefined,
};
